import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export const CALLBACK_OUTCOMES = [
  { value: 'ORDER_CREATED', label: 'Заказ создан' },
  { value: 'CONSULTED', label: 'Консультация завершена' },
  { value: 'NO_STOCK', label: 'Нет нужного товара' },
  { value: 'NO_ANSWER', label: 'Нет ответа — перезвонить ещё' },
  { value: 'INVALID', label: 'Неверный номер / спам' },
  { value: 'DUPLICATE', label: 'Дубликат обращения' },
  { value: 'OTHER', label: 'Другой результат' }
];

@Component({
  selector: 'app-callback-outcome-dialog',
  template: `
    <h2 mat-dialog-title>Результат обращения</h2>
    <mat-dialog-content>
      <mat-form-field appearance="outline">
        <mat-label>Что произошло</mat-label>
        <mat-select [(ngModel)]="outcome" required>
          <mat-option *ngFor="let item of options" [value]="item.value">{{ item.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Комментарий / номер заказа</mat-label>
        <textarea matInput [(ngModel)]="note" rows="2" maxlength="500"></textarea>
      </mat-form-field>
      <p *ngIf="outcome === 'NO_ANSWER'">Заявка останется открытой для повторного звонка.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Назад</button>
      <button mat-raised-button color="primary" [disabled]="!canSave" (click)="save()">Сохранить</button>
    </mat-dialog-actions>
  `,
  styles: ['mat-form-field { display: block; width: 100%; }']
})
export class CallbackOutcomeDialogComponent {
  readonly options = CALLBACK_OUTCOMES;
  outcome = '';
  note = '';
  constructor(private dialog: MatDialogRef<CallbackOutcomeDialogComponent>) {}
  get canSave(): boolean { return Boolean(this.outcome && (this.outcome !== 'OTHER' || this.note.trim())); }
  save(): void { if (this.canSave) this.dialog.close({ outcome: this.outcome, note: this.note.trim() }); }
}
